module.exports = __webpack_public_path__ + "img/db.e046db35.svg";